import React, { Component } from 'react';
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
//import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Text } from '../../extensions/LangaugeContainer';
class FirmaDialog extends Component {
  state = {
    selectedFirmaAppUniqueId: ''
  };

  handleChange = e => {
    this.setState({ selectedFirmaAppUniqueId: e.target.value });
  };

    render() {
      let firms = this.props.appointments || [];
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth={true}
                >
                <DialogTitle id="alert-dialog-title"><Text tid="company"/></DialogTitle>
                <DialogContent>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="firma"><Text tid="company"/></InputLabel>
                    <Select
                      value={this.state.selectedFirmaAppUniqueId}
                      onChange={this.handleChange}
                      input={<Input id="firma" />}
                      fullWidth
                    >
                      <MenuItem value="">
                        <em><Text tid="none"/></em>
                      </MenuItem>
                      {firms.map(item => (<MenuItem key={item.UniqueID} value={item.UniqueID}>{item.EkName}</MenuItem>))}
                    </Select>
                  </FormControl>

                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary" name="Cancel">
                    <Text tid="cancel"/>
                    </Button>
                    <Button onClick={() => this.props.leaveBockToLocation(this.state.selectedFirmaAppUniqueId)} color="primary" autoFocus>
                    <Text tid="save"/>
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = state => ({
  appointments: state.tasks.appointments
});

export default
  connect(
    mapStateToProps, {}
  )(FirmaDialog);
